var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tooltip.text)?_c('div',{ref:"tooltip",staticClass:"floating-tooltip",class:{visible: _vm.tooltip.active && !_vm.touch},style:(_vm.position),domProps:{"innerHTML":_vm._s(_vm.tooltip.text)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }